export default __webpack_public_path__ + "ed8ee2ae20859bcefdf910a02a3b623c.svg";